import React, { useState, useEffect } from 'react'
import StartRate from '../../components/rating'
import ImageDragDrop from '../../components/multipleimageupload'
import 'react-toastify/dist/ReactToastify.css' // Import the styles for the toast notifications
import { ToastContainer, toast } from 'react-toastify'
import { feedback } from '../../services/data/index.js'
import useChatbotLoader from '../../util/chatbotloader.js'
import { useLocation, useParams } from 'react-router-dom'

const FeedBack = () => {
  // useChatbotLoader("","")
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    rating: '',
    suggestion: '',
    attachments: []
  })

  const [error, setError] = useState('')
  const [uploadedFiles, setUploadedFiles] = useState([])

  const location = useLocation()
  const params = useParams()

  // ✅ Extract store_id from URL (params or pathname)
  const getStoreIdFromUrl = () => {
    if (params?.store_id) return params.store_id
    const pathParts = location.pathname.split('/')
    console.log(pathParts[1])
    return pathParts[1] || null
  }

  const store_id = getStoreIdFromUrl()

  const handleInputChange = e => {
    const { name, value } = e.target
    setFormData(prevData => ({ ...prevData, [name]: value }))
  }

  const handleFilesChange = newFiles => {
    setUploadedFiles(newFiles) // Update the state with the new files
  }

  //   useEffect(() => {
  //     console.log('Uploaded Files:', uploadedFiles);
  //   }, [uploadedFiles]);

  const handleRatingChange = calculatedRating => {
    setFormData(prevData => ({ ...prevData, rating: calculatedRating }))
  }

  const handleSubmit = async e => {
    e.preventDefault()

    // Validate mandatory fields
    if (
      !formData.name.trim() ||
      !formData.email.trim() ||
      !formData.suggestion.trim()
    ) {
      toast.error('Name, Email, and Message are required fields.')
      return
    }

    // Prepare the feedback data in the required format
    const feedbackData = {
      store_id: store_id,
      name: formData.name.trim(),
      email: formData.email.trim(),
      message: formData.suggestion.trim(),
      attachments:
        uploadedFiles.length > 0
          ? uploadedFiles.map(file => file.url)
          : undefined
    }

    try {
      const response = await feedback(feedbackData)
      if (response.success) {
        toast.success(response.message)
        setFormData({
          name: '',
          email: '',
          rating: '',
          suggestion: '',
          attachments: []
        })
        setUploadedFiles([])
        window.dispatchEvent(
          new CustomEvent('feedbackSubmitted', { detail: true })
        )
      }
    } catch (error) {
      toast.error(error.message || 'Something went wrong')
    }
  }

  return (
    <div className='flex items-center justify-center min-h-screen bg-transparent p-6'>
      <div className='bg-white p-8 rounded-[16px] shadow-md w-full max-w-lg'>
        <h1 className='text-[23px] font-extrabold '>Support Desk</h1>
        <p class='font-medium mt-1 text-[#252530] text-[12px] '>
          Let us know how we can help you better!
        </p>
        <form onSubmit={handleSubmit} className='space-y-4 mt-6'>
          <div>
            <label htmlFor='name' className='block text-sm mb-2  font-medium'>
              Name:
            </label>
            <input
              type='text'
              id='name'
              name='name'
              value={formData.name}
              onChange={handleInputChange}
              required
              className='w-full px-4 py-2 border rounded-lg focus:outline-none'
            />
          </div>
          <div>
            <label htmlFor='email' className='block mb-2  text-sm font-medium'>
              Contact Email:
            </label>
            <input
              type='email'
              id='email'
              name='email'
              value={formData.email}
              onChange={handleInputChange}
              required
              className='w-full px-4 py-2 border rounded-lg focus:outline-none'
            />
          </div>
          {/* <div>
            <label htmlFor='rating' className='block text-sm font-medium mb-2 '>
              Rating:
            </label>
            <StartRate onRatingChange={handleRatingChange} />
          </div> */}
          <div>
            <label
              htmlFor='suggestion'
              className='block text-sm font-medium mb-2 '
            >
              Write a message:
            </label>
            <textarea
              id='suggestion'
              name='suggestion'
              value={formData.suggestion}
              onChange={handleInputChange}
              required
              className='w-full px-4 py-2 border rounded-lg focus:outline-none'
              rows='4'
              maxLength={255}
            ></textarea>
          </div>
          <div>
            <label
              htmlFor='attachments'
              className='block text-sm font-medium mb-2 '
            >
              Attachment (Max 2MB each):
            </label>
            <ImageDragDrop onFilesChange={handleFilesChange} />
            {error && <p className='text-red-500 text-sm mt-1'>{error}</p>}
          </div>
          <button
            type='submit'
            className='w-full bg-[#232328]  rounded-[59px] text-white py-2 px-4  transition'
          >
            Submit
          </button>
        </form>
      </div>
      <ToastContainer />
    </div>
  )
}

export default FeedBack
